import { render, staticRenderFns } from "./CommonAncillaryAvatar.vue?vue&type=template&id=51fc67dc"
import script from "./CommonAncillaryAvatar.vue?vue&type=script&lang=js"
export * from "./CommonAncillaryAvatar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports